import * as fromDatatype from '../datatype-library/index';
import { QueryParamsJsonDatatypeInterface } from './bl_cms_menu_hdr.model';

export interface bl_cms_post_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  layout_guid: fromDatatype.GuidDataFieldInterface;
  author_name: fromDatatype.VarcharDatatypeInterface;
  author_guid: fromDatatype.GuidDataFieldInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  post_property_json: fromDatatype.JsonDatatypeInterface;
  created_by_guid: fromDatatype.GuidDataFieldInterface;
  modified_by_guid: fromDatatype.GuidDataFieldInterface;
  publish_date: fromDatatype.TimestampTzDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.TextDatatypeInterface;
  summary: fromDatatype.TextDatatypeInterface;
  content_option: fromDatatype.VarcharDatatypeInterface;
  content_component_guid: fromDatatype.GuidDataFieldInterface;
  content_external: fromDatatype.VarcharDatatypeInterface;
  content_body: fromDatatype.TextDatatypeInterface;
  property_json: QueryParamsJsonDatatypeInterface;
  seo_schema_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  pix_thumbnail_guid: fromDatatype.GuidDataFieldInterface;
  pix_banner_guid: fromDatatype.GuidDataFieldInterface;
  pix_content_guid: fromDatatype.GuidDataFieldInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  post_type: fromDatatype.VarcharDatatypeInterface;
  post_category: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  widget_instance_hdr_guid: fromDatatype.GuidDataFieldInterface;
  post_status: fromDatatype.VarcharDatatypeInterface;
  thumbnail_option: fromDatatype.VarcharDatatypeInterface;
  thumbnail_body: fromDatatype.VarcharDatatypeInterface;
  layout_instance_guid: fromDatatype.GuidDataFieldInterface;
  meta_desc: fromDatatype.VarcharDatatypeInterface;
  title_writer: fromDatatype.VarcharDatatypeInterface;
  scheme_generator: fromDatatype.JsonDatatypeInterface;
  post_category_guid: fromDatatype.GuidDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  total_view_count: fromDatatype.NumericDatatypeClass;
  total_comment_count: fromDatatype.NumericDatatypeClass;
  name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_post_hdr_RowClass
  implements bl_cms_post_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  layout_guid: fromDatatype.GuidDataFieldInterface;
  author_name: fromDatatype.VarcharDatatypeInterface;
  author_guid: fromDatatype.GuidDataFieldInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  post_property_json: fromDatatype.JsonDatatypeInterface;
  created_by_guid: fromDatatype.GuidDataFieldInterface;
  modified_by_guid: fromDatatype.GuidDataFieldInterface;
  publish_date: fromDatatype.TimestampTzDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.TextDatatypeInterface;
  summary: fromDatatype.TextDatatypeInterface;
  content_option: fromDatatype.VarcharDatatypeInterface;
  content_component_guid: fromDatatype.GuidDataFieldInterface;
  content_external: fromDatatype.VarcharDatatypeInterface;
  content_body: fromDatatype.TextDatatypeInterface;
  property_json: QueryParamsJsonDatatypeInterface;
  seo_schema_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  pix_thumbnail_guid: fromDatatype.GuidDataFieldInterface;
  pix_banner_guid: fromDatatype.GuidDataFieldInterface;
  pix_content_guid: fromDatatype.GuidDataFieldInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  post_type: fromDatatype.VarcharDatatypeInterface;
  post_category: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  widget_instance_hdr_guid: fromDatatype.GuidDataFieldInterface;
  post_status: fromDatatype.VarcharDatatypeInterface;
  thumbnail_option: fromDatatype.VarcharDatatypeInterface;
  thumbnail_body: fromDatatype.VarcharDatatypeInterface;
  layout_instance_guid: fromDatatype.GuidDataFieldInterface;
  meta_desc: fromDatatype.VarcharDatatypeInterface;
  title_writer: fromDatatype.VarcharDatatypeInterface;
  scheme_generator: fromDatatype.JsonDatatypeInterface;
  post_category_guid: fromDatatype.GuidDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  total_view_count: fromDatatype.NumericDatatypeClass;
  total_comment_count: fromDatatype.NumericDatatypeClass;
  name: fromDatatype.VarcharDatatypeInterface;
}
